var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M42.72 32.02a4.14 4.14 0 00-4.12-4.6h-.38a4.14 4.14 0 00-4.12 4.6l1 8.92a3.33 3.33 0 003.3 2.96h.01c1.7 0 3.13-1.27 3.31-2.96l1-8.92z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.17,
    cy: 52.2,
    r: 4.2,
    className: "stroke fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    strokeDasharray: "9,9,0,0",
    d: "M34.39 15.05l.27-.33a4.17 4.17 0 016.73.55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M44.56 21.25l4.23 7.4m-31.9 5.45l13.73-24.05a7.92 7.92 0 0113.76 0L71.24 57.1a7.92 7.92 0 01-6.88 11.85H10.64a7.92 7.92 0 01-6.88-11.86l2.49-4.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.26042d0c5c59294b5b26b65820a04707.svg";
export { ForwardRef as ReactComponent };